import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import PaymentCardListUI from '../../components/accountSettings/paymentCard/PaymentCardListUI'

const PaymentCardListPageUI = ({context, messageList, paymentCardList,
      // form
      successMsg, errorList, setErrorList,
      // modes
      selectedCount, updateMode, deleteMode, submitted,
      // event handlers
      onRowClick, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick,
      // event handlers in modals
      onConfirmUpdateClick, onConfirmDeleteClick, onCancelClick,
    }) =>
  <PrivatePageSF context={context} className='pg_acc_cards' backLink='/settings/account/fin'
    centered={!paymentCardList || (errorList && errorList.length > 0)}
    messageList={messageList} headerMessageKey='c_payment_cards'>
    {
      !paymentCardList && !(errorList && errorList.length) > 0 &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      paymentCardList && !(errorList && errorList.length) > 0 &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings/account/fin'
          messageList={messageList} titleMessageKey='c_payment_cards'
        />
        <PaymentCardListUI
          context={context}
          paymentCardList={paymentCardList}
          messageList={messageList}
          //
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick}
          onRowClick={onRowClick}
        />
      </div>
    }
  </PrivatePageSF>

export default PaymentCardListPageUI
